import { BatchesService } from '@festina/legalentity-general-types/legalentity/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServiceDeleteDelete
type MethodParam = Parameters<typeof method>[0]

export const useDeleteLegalEntityBatch = () =>
  useFestinaMutation({
    component: 'legalEntity',
    isScenario: false,
    roles: BatchesService.batchesServiceDeleteDelete_roles,
    mutateFunction: async (arg: MethodParam) => await method(arg),
  })
